import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row,
    Container, FormGroup, Label, Input, Form
} from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import { FileIcon, defaultStyles } from 'react-file-icon';
import { useState } from 'react';
import { useDispatch } from "react-redux";
import MainDropzone from 'react-dropzone';
interface IDropzone {
    modal: boolean,
    toggle: () => void,
    className?: string,
    importData: (data: any) => void
}


export default function Dropzone({ modal, toggle, className, importData }: IDropzone) {
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({ maxFiles: 2 });
    const dispatch = useDispatch();
    const [files, setFiles] = useState<any>([]);

    const uploadFile = () => {
        const formData = new FormData();
        formData.append('file', files[0]);
        importData(formData);
        const newFiles = [...files];
        newFiles.splice(0, 1);
        setFiles(newFiles);
        toggle();
    }

    const handleDrop = (acceptedFiles: any)=>{
        // console.log(acceptedFiles)

        setFiles([...acceptedFiles]);

    }
    const removeFile = ()=>{
        setFiles([])
    }

    return <Modal isOpen={modal} toggle={()=>{toggle(), removeFile()}} className={className} size={"l"} centered fullscreen="xl">
        <ModalHeader toggle={()=>{toggle(), removeFile()}}>
            import file
        </ModalHeader>
        <ModalBody>
            <Container className={`d-flex  justify-content-center  align-items-center w-100`}>
                <MainDropzone onDrop={handleDrop}>
                    {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps({ className: 'dropzone w-100' })}>
                            <input {...getInputProps()} />
                            <p>Drag 'n' drop  file here, or click to select files</p>
                            {files.length > 0 && <div style={{ width: 48, margin: 16 }} >
                                <FileIcon extension={files[0].path?.split('.').pop()} {...defaultStyles[files[0].path.split('.').pop()]} />
                                <p >{files[0].path}</p>
                            </div>}
                        </div>
                    )}

                </MainDropzone>

            </Container>
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={uploadFile}>
                validate
            </Button>
            <Button color="secondary" onClick={()=>{toggle(), removeFile()}} >
                Cancel
            </Button>
        </ModalFooter>
    </Modal>
}